import Cookies from "js-cookie";

export const GetHeaders = () => {
    var token = "Bearer" + " " + localStorage.getItem('token');
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': token,
        'currentContractorId': Cookies.get('currentContractorId')
    }

    return headers;
}

export const GetHeadersStorege = () => {
    var token = "Bearer" + " " + localStorage.getItem('token');

    const headers = {
        'Content-Type': 'application/json',
        'Authorization': token,
        'currentContractorId': Cookies.get('currentContractorId')
    }

    return headers;

}

export const GetHeadersJustJson = () =>{
    const headers = {
        'Content-Type': 'application/json',
    }

    return headers;
}